import posthog from 'posthog-js';

let initialised = false;

/**
 * Inert when NEXT_PUBLIC_POSTHOG_KEY is unset OR the user hasn't accepted
 * analytics cookies. Idempotent.
 */
export function initPosthog(): boolean {
  if (initialised) return true;
  if (typeof window === 'undefined') return false;
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!key) return false;

  posthog.init(key, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
    persistence: 'localStorage',
  });
  initialised = true;
  return true;
}

export function shutdownPosthog(): void {
  if (!initialised) return;
  posthog.opt_out_capturing();
  initialised = false;
}

export function isPosthogReady(): boolean {
  return initialised;
}

export { posthog };
